import { List, styled } from '@mui/material';

import { useParams } from 'react-router';

import {
  Statistics,
  SingleUserReview,
  useGetScenarioReviewsQuery,
  useScenarioDetailsContext,
} from '@app-velocity/modules/scenarios';
import { Button, Skeleton, Typography } from '@app-velocity/ui';
import { useI18n } from '@app-velocity/i18n';
import { MessageBus } from '@app-velocity/message-bus';

import { PeopleIcon, ShareIcon } from '@app-velocity/icons';

import { RenderReviewClickMapButton } from '../RenderReviewClickMapButton';
import { RenderClickMapButton } from '../RenderClickMapButton';
import { SectionHeader } from '../SectionHeader';

const messageBus = new MessageBus('prototypes');

const StyledNoReviewsInfo = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  textAlign: 'center',
  padding: theme.spacing(4),
}));

const StyledOverallHeatmap = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(4)} 0`,
}));

export const ReviewsData = () => {
  const { workspaceId, scenarioId } = useParams<{
    workspaceId: string;
    scenarioId: string;
  }>();
  const { scenario } = useScenarioDetailsContext();

  const { t } = useI18n();
  const { data: reviews, isLoading: areReviewsLoading } =
    useGetScenarioReviewsQuery(workspaceId, scenarioId);

  const openShareScenarioModal = () => {
    if (!scenario.shareToken || !scenario.id) return;

    messageBus.publish('modal:share-scenario:open', {
      shareToken: scenario.shareToken,
      prototypeId: scenario.id,
    });
  };

  if (areReviewsLoading) return <Skeleton borderRadius={2} height={50} />;

  return (
    <>
      <SectionHeader
        title="prototypes:human_testing"
        icon={<PeopleIcon />}
        right={
          scenario.finalTriggerElement ? (
            <Button
              size="small"
              variant="contained"
              color="secondary"
              onClick={openShareScenarioModal}
            >
              {t('prototypes:set_up_human_testing')}
              <ShareIcon />
            </Button>
          ) : null
        }
      />

      <Statistics />
      {!reviews || reviews.length === 0 ? (
        <StyledNoReviewsInfo>{t('prototypes:no_reviews')}</StyledNoReviewsInfo>
      ) : (
        <>
          <StyledOverallHeatmap>
            <RenderClickMapButton />
          </StyledOverallHeatmap>
          <List disablePadding dense>
            {reviews?.map((review) => (
              <SingleUserReview
                key={review.id}
                review={review}
                actions={<RenderReviewClickMapButton />}
              />
            ))}
          </List>
        </>
      )}
    </>
  );
};
